import React, { useState, useEffect } from "react";
import { useAuth } from '../../../../../../../context/AuthContext';
import { useTranslation } from "react-i18next";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import axios from "axios";
import 'quill/dist/quill.snow.css'
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router-dom';
import Datatable from "../../../../Components/Datatable"
import Choice from "../QuestionListTypes/Choice"
import Match from "../QuestionListTypes/Match"
import VideoContent from "../QuestionListTypes/VideoContent"
import Write from "../QuestionListTypes/Write"
import RealMatch from "../QuestionListTypes/RealMatch"
import TrueFalse from "../QuestionListTypes/TrueFalse"
import Sentence from "../QuestionListTypes/Sentence"

export const QuestionListBySubject = () => {
    const [data, setData] = useState([]);
    const [deletedData, setdeletedData] = useState([]);
    const [indexx, setIndexx] = useState(''); // Kullanıcının girdiği index değeri

    const [loading, setLoading] = useState(true);
    const { t, i18n } = useTranslation();
    const { user } = useAuth();
    const [msg, setMsg] = useState([]);
    const params = useParams()

    const navigate = useNavigate();





    const searchDiv = () => {

        window.location.hash = document.getElementById('searchBox').value;  // Hedef öğenin ID'sine göre hash'i ayarla

    };
    useEffect(() => {

        const fetchdataa = async () => {
            try {
                const headerss = {
                    "accept": "*/*",
                    'Content-Type': 'application/json',
                    'Access-Control-Allow-Credentials': 'false',
                    'Authorization': 'Bearer ' + user.token
                }
                let url = "https://api.heryerdeingilizce.com/api/admin/ContentManager/GetListBySubject";
                await axios({
                    method: 'GET',
                    url: url,
                    headers: headerss,
                    params: {
                        subjectId: params["subject"]
                    }
                }).then(res => {
                    if (res.status === 200) {
                        if (res.data['success']) {
                            for (let i = 0; i < res.data['data'].length; i++) {
                                if (res.data['data'][i]['isDeleted'] === false) {
                                    data.push({
                                        "id": res.data['data'][i]['id'],
                                        "contentType": res.data['data'][i]['contentType'],
                                        "contentStr": res.data['data'][i]['contentStr'],
                                        "answer": res.data['data'][i]['answer'],
                                        "detail": res.data['data'][i]['detail'],
                                        "notfyText": res.data['data'][i]['notfyText'],
                                        "sortId": res.data['data'][i]['sortId'],
                                        "tagId": res.data['data'][i]['tagId'],
                                        "subjectId": res.data['data'][i]['subjectId']
                                    })
                                }
                                // else {
                                //     deletedData.push({
                                //         "id": res.data['data'][i]['id'],
                                //         "contentType": res.data['data'][i]['contentType'],
                                //         "contentStr": res.data['data'][i]['contentStr'],
                                //         "answer": res.data['data'][i]['answer'],
                                //         "detail": res.data['data'][i]['detail'],
                                //         "notfyText": res.data['data'][i]['notfyText'],
                                //         "sortId": res.data['data'][i]['sortId'],
                                //         "tagId": res.data['data'][i]['tagId'],
                                //         "subjectId": res.data['data'][i]['subjectId']
                                //     })
                                // }
                            }
                        }
                        else {
                            setMsg(res.data['message']);
                        }
                    }
                    else {
                        setMsg("Beklenmedik Bir Hata Oluştu. Tekrar Deneyiniz.");
                    }
                });
            }
            catch (err) {
                setMsg(err);
            }
            setLoading(false);
        }
        fetchdataa();
    }, [])


    if (!loading) {
        return (
            <div>
                <br />
                <div style={{ alignContent: "center", alignItems: "center", border: "1px solid black", padding: "10px" }} >
                    <input type="number" id="searchBox" style={{ height: "40px" }} placeholder="Soru numarası girin" />
                    <button type="button" className="btn btn-info" style={{ marginLeft: "5px" }} onClick={searchDiv}>Ara</button>
                </div>
                <br />
                {
                    data && data.map((dt, index) => {
                        if (dt['contentType'] === "choice") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>
                                    <div style={{ textAlign: "center" }}>
                                        <h5>Çoktan Seçmeli - soru no: {index + 1}</h5> <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br />
                                    </div>
                                    <Choice data={dt} />
                                </div >
                            )
                        }
                        else if (dt['contentType'] === "match") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>
                                    <div style={{ textAlign: "center" }}> <h5>unscramble - soru no: {index + 1}</h5> <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br /> </div>
                                    <Match data={dt} />
                                </div >
                            )
                        }
                        else if (dt['contentType'] === "video") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>
                                    <div style={{ textAlign: "center" }}> <h5>VİDEO DERS - soru no: {index + 1}</h5>  <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br /></div>
                                    <VideoContent data={dt} />
                                </div >
                            )
                        }
                        else if (dt['contentType'] === "write") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>
                                    <div style={{ textAlign: "center" }} > <h5>Write - soru no: {index + 1}</h5> <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br /> </div>
                                    <Write data={dt} />
                                </div >
                            )
                        }
                        else if (dt['contentType'] === "sentence") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>
                                    <div style={{ textAlign: "center" }} > <h5>Cümle oluşturma - soru no: {index + 1}</h5> <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br /> </div>
                                    <Sentence data={dt} />
                                </div >
                            )
                        }
                        else if (dt['contentType'] === "realmatch") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>

                                    <div style={{ textAlign: "center" }} > <h5>match - soru no: {index + 1}</h5>  <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br /></div>
                                    <RealMatch data={dt} />
                                </div >
                            )
                        }
                        else if (dt['contentType'] === "truefalse") {
                            return (
                                <div key={index + 1} id={index + 1} style={{ border: "1px solid black", padding: "2%" }}>
                                    <div style={{ textAlign: "center" }} > <h5>truefalse - soru no: {index + 1}</h5>
                                        <br />
                                        <a href={"/admin/createquestionbysortid/" + dt.id + "/" + dt.subjectId} className="btn btn-warning">Soruyu Yeniden Oluştur</a>
                                        <br /><br />
                                    </div>
                                    <TrueFalse data={dt} />

                                </div >
                            )
                        }
                    })

                }
            </div >
        )

    }

}
export default QuestionListBySubject;



